<template>
    <div class="flex flex-col lg:grid lg:grid-cols-3 gap-10 bg-white">
        <div class="col-span-2 p-5 lg:p-10 bg-sand lg:flex lg:items-stretch gap-10">
            <div class="flex-1 min-w-0 flex flex-col gap-5">
                <Tag :title="article.tag" />
                <h2 v-html="article.heading" />
                <p v-if="article.author" class="my-2 text-sm text-gray-600">
                    {{ article.author }}
                </p>
                <p v-html="article.extract" class="leading-6" />
                <Link :href="article.url" :text="article.linkText" />
            </div>
            <div class="flex-1 pt-10 lg:pt-0 lg:relative lg:overflow-hidden">
                <img v-if="imageUrl" :src="imageUrl"
                    class="w-full object-cover lg:absolute lg:inset-0 lg:h-full lg:w-full" />
            </div>
        </div>
        <div class="flex flex-col w-full gap-5 p-5 lg:p-10 bg-surface-green-20">
            <Tag :title="rightcontent.tag" />
            <h2>
                {{ rightcontent.header }}
            </h2>
            <div v-if="rightcontent.ingress" class="mb-4 font-semibold">
                {{ rightcontent.ingress }}
            </div>
            <Link v-for="link in rightcontent.links" v-epi-edit="'TopRightLinks'" :key="link.title" :href="link.href"
                :text="link.text" :target="link.target" :title="link.title" />
        </div>
    </div>
</template>

<script>
import Link from '@/Scripts/components/atoms/Link/Link.vue';
import Tag from '@/Scripts/components/atoms/Tag/Tag.vue';

export default {
    props: ['article', 'url', 'rightcontent'],
    components: {
        Tag,
        Link,
    },
    computed: {
        imageUrl() {
            console.log(this.article.author);
            if (this.article.image === null) {
                return null;
            } else {
                return this.article.image + '?width=638&height=900&' + this.article.imageResizerParams;
            }
        },
        rightImageUrl() {
            if (this.rightcontent.image === null) {
                return null;
            } else {
                return this.rightcontent.image + '?width=638&height=425&' + this.rightcontent.imageResizerParams;
            }
        }
    }
};
</script>
